import Container from './Container';
import Button from './Button';

export default function HeroSection({
  imageSrc,
  imageAlt,
  imagePosition = 'right', // 'left' o 'right'
  imageOffsetClass = '', // override per la posizione dell'immagine principale
  topLabel,
  title,
  subtitle,
  buttons = [],
  priority = false, // true sulla home: aggiunge fetchpriority=high
  mobileImage = null, // immagine full-bleed sopra il testo su mobile
  mobileImageFilter = null,
  sideImage = null, // piccola testa/elemento da posizionare sul lato (desktop)
  sideImageAlt = '',
  sideImageOffsetClass = '' // classi per spostare/posizionare il sideImage (override)
}) {
  const isImageLeft = imagePosition === 'left';

  return (
    <section
      className={`w-screen relative left-1/2 right-1/2 -mx-[50vw] bg-cover bg-center overflow-hidden ${mobileImage ? 'min-h-screen md:min-h-0' : ''}`}
      style={{
        backgroundImage: 'url(/decorazionebg.webp)',
        minHeight: mobileImage ? undefined : '50vh'
      }}
    >
      {/* Overlay per opacità */}
      <div className="absolute inset-0 bg-white opacity-70"></div>

      {/* Immagine ragazza full-bleed su mobile */}
      {mobileImage && (
        <div className="md:hidden absolute inset-x-0 top-0 h-[58vh]">
          <img
            src={mobileImage}
            alt=""
            className="w-full h-full object-cover object-top"
            style={mobileImageFilter ? { filter: mobileImageFilter } : {}}
            loading={priority ? 'eager' : 'lazy'}
            fetchPriority={priority ? 'high' : 'auto'}
          />
          {/* Gradiente in basso per sfumare nel testo */}
          <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-white/90 to-transparent" />
        </div>
      )}

      <div className={`px-4 py-6 md:py-12 relative h-full ${mobileImage ? 'pt-[calc(58vh-32px)] md:pt-6' : ''}`}>
        <Container>
          <div
            className={`relative flex items-center ${isImageLeft ? 'justify-center md:justify-end' : 'justify-center md:justify-start'}`}
            style={{ minHeight: mobileImage ? undefined : '45vh' }}
          >
            {/* Immagine ragazza - solo desktop */}
            <div
              className={`hidden md:block absolute z-5 -bottom-[60px] md:-bottom-[100px] ${
                imageOffsetClass ? imageOffsetClass : (isImageLeft ? 'left-0 md:-left-[360px]' : 'right-0 md:-right-[280px]')
              }`}
            >
              <img
                src={imageSrc}
                alt={imageAlt}
                className="w-auto object-contain object-bottom"
                style={{ height: 'calc(60vh + 60px)' }}
                loading={priority ? 'eager' : 'lazy'}
                fetchPriority={priority ? 'high' : 'auto'}
              />
            </div>

            {/* Side small image (e.g. testa della ragazza) - opzionale */}
            {sideImage && (
              <div className={`hidden md:block absolute z-10 top-6 ${isImageLeft ? 'left-6 md:-left-24' : 'right-6 md:-right-[280px]'} ${sideImageOffsetClass}`}>
                <img src={sideImage} alt={sideImageAlt} className="w-24 h-24 object-cover rounded-full" style={{ objectPosition: 'center right' }} />
              </div>
            )}

            {/* Contenuto */}
            <div className="relative z-10 max-w-2xl md:max-w-lg text-center md:text-left">
              {topLabel && (
                <div className="mb-4">
                  <span className="inline-block font-sans text-xs md:text-sm uppercase tracking-[0.2em] text-accent font-medium">
                    {topLabel}
                  </span>
                </div>
              )}

              <h1 className="font-serif text-5xl md:text-6xl font-semibold text-primary mb-3">
                {title}
              </h1>
              <p className="text-lg md:text-xl text-taupe mb-5">
                {subtitle}
              </p>

              {/* Pulsanti */}
              {buttons.length > 0 && (
                <div className="flex gap-4 flex-wrap justify-center md:justify-start">
                  {buttons.map((button, index) => (
                    <div key={index} className={button.hideOnMobile ? 'hidden md:block' : ''}>
                      <Button variant={button.variant} href={button.href}>
                        {button.text}
                      </Button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </Container>
      </div>
    </section>
  );
}
